import React, { useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsProgress, faBoxOpen, faChartSimple, faComments, faKey, faLayerGroup, faNetworkWired, faShirt, faTags, faTimes, faUserLock, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../hooks/AuthProvider';



function SideBar({ handleSidebarToggle, handleBreadcrumChange }) {

    const auth = useAuth();
    const location = useLocation();

    useEffect(() => {
        //console.log('Route changed to:', location.pathname);
        //const path=location.pathname.replace('/', '').replace('-',' ');
        const path=location.pathname.split('/')[1].replace('-',' ');
        const title = capitalizeFirstLetter(path);
        const navigation = path;
        handleBreadcrumChange(title, navigation);
    }, [location]);

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        <React.Fragment>
            <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 ps ps--active-y bg-white" id="sidenav-main">
                <div className="sidenav-header">
                    <FontAwesomeIcon className='p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none' ria-hidden="true" id="iconSidenav" icon={faTimes} onClick={handleSidebarToggle} />
                    <a className="navbar-brand m-0 d-flex justify-content-center align-items-center" href="/dashboard">
                        <img src={require('../../assets/img/gb-logo.jpg')} className="navbar-brand-img h-100" alt="main_logo" />
                        <span className="ms-1 font-weight-bold">Admin Portal</span>
                    </a>
                </div>
                <hr className="horizontal dark mt-0" />
                <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/dashboard" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faLayerGroup}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Dashboard</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/category" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faNetworkWired}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Category</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/product" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faShirt}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Product</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/order" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faBoxOpen}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Order</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/user" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faUsers}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">User</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/coupon" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faTags}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Coupon</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/feedback" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faComments}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Feedback</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/get-in-touch" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faComments}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Get in Touch</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/banner" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faBarsProgress}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Banner</span>
                            </NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/report" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faChartSimple}></FontAwesomeIcon>
                                </div>
                                <span className="nav-link-text ms-1">Report</span>
                            </NavLink>
                        </li> */}
                        <li className="nav-item d-xl-none">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/change-password" >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faKey} />
                                </div>
                                <span className="nav-link-text ms-1">Change password</span>
                            </NavLink>
                        </li>
                        <li className="nav-item d-xl-none">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to={""} onClick={() => auth.logOut()} >
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faUserLock} />
                                </div>
                                <span className="nav-link-text ms-1">Sign out</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </aside>
        </React.Fragment>
    );
}

export default SideBar